import React, { useRef, useEffect, useState } from "react";
import useYDocsManager from "./useYDocsManager";
import useCanvasManager from "./useCanvasManager";
import useShaderManager from "./useShaderManager";

const DrawingCanvas = () => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [currentPosition, setCurrentPosition] = useState({ x: 0, y: 0 });
  const [previousPosition, setPreviousPosition] = useState({ x: 0, y: 0 });
  const id = useYDocsManager((state) => state.id);

  const yDocsRef = useYDocsManager((state) => state.yState);
  const drawing = useCanvasManager((state) => state.peers);
  const color = useCanvasManager((state) => state.color);
  const show = useCanvasManager((state) => state.hide);
  const deletePeer = useCanvasManager((state) => state.deletePeer);
  const update = useCanvasManager((state) => state.update);
  const vedaRef = useShaderManager((state) => state.vedaRef);

  useEffect(() => {
    const canvas = canvasRef.current;
    update("doodleRef", canvas);
    const context = canvas.getContext("2d");

    context.fillStyle = "transparent";
    context.fillRect(0, 0, canvas.width, canvas.height);
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    const handleMouseDown = (event) => {
      setIsDrawing(true);
      setPreviousPosition({ x: event.clientX, y: event.clientY });
    };

    const handleMouseMove = (event) => {
      if (!isDrawing) return;
      setCurrentPosition({ x: event.clientX, y: event.clientY });
    };

    const handleMouseUp = () => {
      setIsDrawing(false);
      setCurrentPosition({ x: 0, y: 0 });
      setPreviousPosition({ x: 0, y: 0 });
    };

    const handleKeyDown = (event) => {
      if (event.code === "Space") {
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
      }
    };

    canvas.addEventListener("mousedown", handleMouseDown);
    canvas.addEventListener("mousemove", handleMouseMove);
    canvas.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      canvas.removeEventListener("mousedown", handleMouseDown);
      canvas.removeEventListener("mousemove", handleMouseMove);
      canvas.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isDrawing]);

  const drawLine = (color, currentPosition, previousPosition) => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    context.lineWidth = 5;
    context.strokeStyle = color;

    if (previousPosition.x !== 0 && previousPosition.y !== 0) {
      context.beginPath();
      context.moveTo(previousPosition.x, previousPosition.y);
      context.lineTo(currentPosition.x, currentPosition.y);
      context.lineCap = "round";

      // Add glow effect
      context.shadowBlur = 20; // Set the blur radius for the glow effect
      context.shadowColor = color; // Set the color of the glow effect

      context.stroke();
    }
    if (vedaRef != null) {
      vedaRef.uniforms["doodle"].value.needsUpdate = true;
    }
  };
  //Adding to peers positios;
  const addToPeers = (isDrawing, currentPosition, previousPosition) => {
    if (yDocsRef) {
      const drawing = yDocsRef.get("drawing");
      drawing[id] = {
        active: isDrawing,
        currentPosition,
        previousPosition,
        color,
      };
      yDocsRef.set("drawing", drawing);
      //console.log("Succesfully updated drawings for", id, "with", currentPosition, previousPosition, color)
    }
  };

  //Drawing canvas positions
  useEffect(() => {
    addToPeers(isDrawing, currentPosition, previousPosition);
    if (!isDrawing) return;
    drawLine(color, currentPosition, previousPosition);
    setPreviousPosition(currentPosition);
  }, [isDrawing, currentPosition]);

  //Drawing from peers positions
  useEffect(() => {
    //console.log("Drawing peer positions:", drawing);
    //console.log(drawing);
    const keys = Object.keys(drawing);
    console.log("Availablie ids:", keys);
    keys?.map((key) => {
      if (key.length > 0 && key != id) {
        const active = drawing[key].active;
        if (!active) {
          return;
        } else {
          const cp = drawing[key].currentPosition;
          const pp = drawing[key].previousPosition;
          const c = drawing[key].color;
          drawLine(c, cp, pp);
        }
      }
    });
  }, [drawing]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Clean the "drawing" dictionary here
      console.log("delete peer", id);
      if (drawing.hasOwnProperty(id)) {
        delete drawing[id];
        yDocsRef.set("drawing", drawing);
      }
      deletePeer(id);
    };

    // Add an event listener for beforeunload
    window.addEventListener("unload", handleBeforeUnload);

    return () => {
      // Remove the event listener when the component unmounts
      window.removeEventListener("unload", handleBeforeUnload);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      width={window.innerWidth}
      height={window.innerHeight}
      style={
        show
          ? { zIndex: 40, position: "absolute", display: "block" }
          : { display: "none" }
      }
    ></canvas>
  );
};

export default DrawingCanvas;

//https://dev.to/nyxtom/realtime-collaborative-drawing-with-canvas-and-webrtc-2d01
/**
 *   const removeFromPeers = (pid) => {
    if (yDocsRef) {
      const drawing = yDocsRef.get("drawing");

      const defaultState = {
        active: false,
        currentPosition: { x: 0, y: 0 },
        previousPosition: { x: 0, y: 0 },
        color,
      };
      if (JSON.stringify(defaultState) == JSON.stringify(drawing[pid])) return;

      drawing[pid] = defaultState;
      yDocsRef.set("drawing", drawing);
      console.log("Removing updated drawings for", pid);
    }
  };

 */
